import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

import { PurpleScreenOfDeath } from "~/psod";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
	component: () => <Outlet />,
	errorComponent: PurpleScreenOfDeath,
});
